import Rellax from "rellax";

class RellaxParallax {
  constructor(selector, options = {}) {
    this.selector = selector;

    this.options = {
      center: true,
      vertical: true,
      horizontal: false,
      ...options,
    };

    this.instance = null;

    this.init();
  }

  init() {
    const elements = document.querySelectorAll(this.selector);

    if (!elements.length) return;

    this.instance = new Rellax(this.selector, this.options);
  }

  refresh() {
    if (!this.instance) return;

    this.instance.refresh();
  }

  destroy() {
    if (!this.instance) return;

    this.instance.destroy();
    this.instance = null;
  }
}

export default RellaxParallax;
